"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "id": "legacy",
    "name": "Legacy",
    "version": "4.1.1",
    "mode": "dark",
    "colors": {
        "color_black": "#000000",
        "color_black_rgb": "0, 0, 0",
        "color_white": "#ffffff",
        "color_white_rgb": "255, 255, 255",
        "color_border": "#949494",
        "color_border_alt": "#494949",
        "color_accent_border": "#febb02",
        "color_action_border": "#3daeff",
        "color_callout_border": "#ff8000",
        "color_border_disabled": "#6b6b6b",
        "color_destructive_border": "#ff5c5c",
        "color_constructive_border": "#69ce6f",
        "color_background": "#d9d9d9",
        "color_background_rgb": "217, 217, 217",
        "color_transparent": "rgba(0, 0, 0, 0)",
        "color_background_alt": "#262626",
        "color_background_alt_rgb": "38, 38, 38",
        "color_cta_background": "#0071c2",
        "color_cta_background_rgb": "0, 113, 194",
        "color_background_base": "#000000",
        "color_background_base_rgb": "0, 0, 0",
        "color_black_with_alpha": "rgba(0, 0, 0, 0.5)",
        "color_accent_background": "#febb02",
        "color_accent_background_rgb": "254, 187, 2",
        "color_action_background": "#0071c2",
        "color_action_background_rgb": "0, 113, 194",
        "color_callout_background": "#ff8000",
        "color_callout_background_rgb": "255, 128, 0",
        "color_background_base_alt": "#000000",
        "color_background_base_alt_rgb": "0, 0, 0",
        "color_background_disabled": "#494949",
        "color_background_disabled_rgb": "73, 73, 73",
        "color_background_inverted": "#f2f2f2",
        "color_background_inverted_rgb": "242, 242, 242",
        "color_accent_background_alt": "#3d2b01",
        "color_accent_background_alt_rgb": "61, 43, 1",
        "color_action_background_alt": "#001e33",
        "color_action_background_alt_rgb": "0, 30, 51",
        "color_callout_background_alt": "#3c1901",
        "color_callout_background_alt_rgb": "60, 25, 1",
        "color_destructive_background": "#cc0000",
        "color_destructive_background_rgb": "204, 0, 0",
        "color_background_disabled_alt": "#262626",
        "color_background_disabled_alt_rgb": "38, 38, 38",
        "color_constructive_background": "#008009",
        "color_constructive_background_rgb": "0, 128, 9",
        "color_brand_primary_background": "#003580",
        "color_brand_primary_background_rgb": "0, 53, 128",
        "color_destructive_background_alt": "#330000",
        "color_destructive_background_alt_rgb": "51, 0, 0",
        "color_constructive_background_alt": "#003303",
        "color_constructive_background_alt_rgb": "0, 51, 3",
        "color_brand_genius_primary_background": "#004cb8",
        "color_brand_genius_primary_background_rgb": "0, 76, 184",
        "color_foreground": "#f2f2f2",
        "color_foreground_alt": "#d9d9d9",
        "color_accent_foreground": "#febb02",
        "color_action_foreground": "#3daeff",
        "color_callout_foreground": "#ff8000",
        "color_foreground_disabled": "#6b6b6b",
        "color_foreground_inverted": "#171717",
        "color_destructive_foreground": "#ff5c5c",
        "color_constructive_foreground": "#69ce6f",
        "color_foreground_disabled_alt": "#494949",
        "color_brand_primary_foreground": "#a3d7fc",
        "color_action_foreground_inverted": "#0071c2",
        "color_brand_genius_secondary_foreground": "#febb02",
        "color_highlighted": "#434343",
        "color_action_focus": "rgba(61, 174, 255, 0.24)",
        "color_cta_highlighted": "#00487a",
        "color_highlighted_alt": "rgba(255, 255, 255, 0.12)",
        "color_destructive_focus": "rgba(255, 92, 92, 0.24)",
        "color_action_highlighted": "#00487a",
        "color_action_highlighted_alt": "rgba(61, 174, 255, 0.12)",
        "color_destructive_highlighted": "#af0e19",
        "color_destructive_highlighted_alt": "rgba(255, 92, 92, 0.12)",
        "color_on_background": "#262626",
        "color_on_cta_background": "#ffffff",
        "color_on_accent_background": "#262626",
        "color_on_action_background": "#ffffff",
        "color_on_callout_background": "#262626",
        "color_on_destructive_background": "#ffffff",
        "color_on_constructive_background": "#ffffff",
        "color_on_brand_primary_background": "#ffffff",
        "color_on_brand_genius_primary_background": "#ffffff",
        "color_background_elevation_one": "#171717",
        "color_background_elevation_two": "#262626",
        "color_background_elevation_two_rgb": "38, 38, 38",
        "color_accent_background_dynamic": "#262626",
        "color_callout_background_dynamic": "#262626",
        "color_destructive_background_dynamic": "#262626",
        "color_constructive_background_dynamic": "#262626",
        "color_brand_primary_background_dynamic": "#262626",
        "color_on_accent_background_dynamic": "#febb02",
        "color_on_callout_background_dynamic": "#ff8000",
        "color_on_destructive_background_dynamic": "#ff5c5c",
        "color_on_constructive_background_dynamic": "#69ce6f",
        "color_on_brand_primary_background_dynamic": "#ffffff"
    },
    "units": {
        "spacing_1x": "4px",
        "spacing_2x": "8px",
        "spacing_3x": "12px",
        "spacing_4x": "16px",
        "spacing_6x": "24px",
        "spacing_8x": "32px",
        "spacing_12x": "48px",
        "spacing_16x": "64px",
        "spacing_24x": "96px",
        "spacing_half": "2px",
        "border_width_100": "1px",
        "border_width_200": "2px",
        "border_radius_100": "2px",
        "border_radius_200": "2px",
        "border_radius_300": "2px"
    },
    "fonts": {
        "small": {
            "font_body_1": {
                "fontSize": "16px",
                "fontWeight": 400,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_body_2": {
                "fontSize": "14px",
                "fontWeight": 400,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_1": {
                "fontSize": "12px",
                "fontWeight": 400,
                "lineHeight": "18px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_2": {
                "fontSize": "10px",
                "fontWeight": 500,
                "lineHeight": "16px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_1": {
                "fontSize": "16px",
                "fontWeight": 700,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_2": {
                "fontSize": "14px",
                "fontWeight": 700,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_1": {
                "fontSize": "40px",
                "fontWeight": 700,
                "lineHeight": "52px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_2": {
                "fontSize": "36px",
                "fontWeight": 700,
                "lineHeight": "48px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_3": {
                "fontSize": "32px",
                "fontWeight": 700,
                "lineHeight": "40px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_1": {
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_2": {
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_3": {
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_1": {
                "fontSize": "28px",
                "fontWeight": 700,
                "lineHeight": "36px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_2": {
                "fontSize": "24px",
                "fontWeight": 700,
                "lineHeight": "32px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_3": {
                "fontSize": "20px",
                "fontWeight": 700,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_1": {
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_2": {
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            }
        },
        "medium": {
            "font_body_1": {
                "fontSize": "16px",
                "fontWeight": 400,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_body_2": {
                "fontSize": "14px",
                "fontWeight": 400,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_1": {
                "fontSize": "12px",
                "fontWeight": 400,
                "lineHeight": "18px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_2": {
                "fontSize": "12px",
                "fontWeight": 500,
                "lineHeight": "18px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_1": {
                "fontSize": "16px",
                "fontWeight": 700,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_2": {
                "fontSize": "14px",
                "fontWeight": 700,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_1": {
                "fontSize": "64px",
                "fontWeight": 700,
                "lineHeight": "72px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_2": {
                "fontSize": "56px",
                "fontWeight": 700,
                "lineHeight": "64px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_3": {
                "fontSize": "48px",
                "fontWeight": 700,
                "lineHeight": "62px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_1": {
                "fontSize": "32px",
                "fontWeight": 400,
                "lineHeight": "40px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_2": {
                "fontSize": "24px",
                "fontWeight": 400,
                "lineHeight": "32px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_3": {
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_1": {
                "fontSize": "32px",
                "fontWeight": 700,
                "lineHeight": "40px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_2": {
                "fontSize": "24px",
                "fontWeight": 700,
                "lineHeight": "32px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_3": {
                "fontSize": "20px",
                "fontWeight": 700,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_1": {
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_2": {
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            }
        },
        "large": {
            "font_body_1": {
                "fontSize": "16px",
                "fontWeight": 400,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_body_2": {
                "fontSize": "14px",
                "fontWeight": 400,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_1": {
                "fontSize": "12px",
                "fontWeight": 400,
                "lineHeight": "18px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_small_2": {
                "fontSize": "12px",
                "fontWeight": 500,
                "lineHeight": "18px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_1": {
                "fontSize": "16px",
                "fontWeight": 700,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_strong_2": {
                "fontSize": "14px",
                "fontWeight": 700,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_1": {
                "fontSize": "96px",
                "fontWeight": 700,
                "lineHeight": "108px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_2": {
                "fontSize": "64px",
                "fontWeight": 700,
                "lineHeight": "72px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_display_3": {
                "fontSize": "48px",
                "fontWeight": 700,
                "lineHeight": "62px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_1": {
                "fontSize": "32px",
                "fontWeight": 400,
                "lineHeight": "40px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_2": {
                "fontSize": "24px",
                "fontWeight": 400,
                "lineHeight": "32px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_featured_3": {
                "fontSize": "20px",
                "fontWeight": 400,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_1": {
                "fontSize": "32px",
                "fontWeight": 700,
                "lineHeight": "40px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_2": {
                "fontSize": "24px",
                "fontWeight": 700,
                "lineHeight": "32px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_headline_3": {
                "fontSize": "20px",
                "fontWeight": 700,
                "lineHeight": "28px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_1": {
                "fontSize": "16px",
                "fontWeight": 500,
                "lineHeight": "24px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            },
            "font_emphasized_2": {
                "fontSize": "14px",
                "fontWeight": 500,
                "lineHeight": "20px",
                "fontFamily": "BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif"
            }
        }
    },
    "shadows": {
        "shadow_100": "0px 2px 8px 0px rgba(0, 0, 0, 0.16)",
        "shadow_200": "0px 2px 16px 0px rgba(0, 0, 0, 0.24)",
        "shadow_300": "0px 4px 16px 0px rgba(0, 0, 0, 0.32)"
    },
    "viewports": {
        "small": "max-width: 575px",
        "medium": "min-width: 576px",
        "large": "min-width: 1024px",
        "xlarge": "min-width: 1280px"
    }
};
